<template>
  <div class="about" id="sobre">
    <div class="background">
      <div class="content">
        <b-container>
          <b-row>
            <b-col lg="6" class="text pr-lg-5">
              <h2 style="font-weight: bold;">{{ $t("tituloSobre") }}</h2>
              <p class="text-content">{{ $t("textoSobre") }}</p>
            </b-col>

            <b-col
              lg="6"
              class="d-flex flex-column justify-content-center align-items-stretch"
            >
              <b-embed
                class="player"
                sm="12"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/7_QNWD4XROw"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sobre",
  components: {},
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");
.content {
  padding-top: 250px;
  padding-bottom: 80px;
}
.about {
  background-image: url("../assets/Sobre/fluid3-web.svg");
  background-repeat: no-repeat;
  background-position: bottom left;
  bottom: -1px;
  background-color: #000000;
}
.background {
  background-image: url("../assets/Sobre/background-web.svg");
  background-repeat: no-repeat;
  background-position: top left;
}
.text {
  color: #ffffff;
  font-family: Roboto, sans-serif;
  font-size: 16.1px;
  text-align: left;
  padding-right: 30px;
  font-weight: 400;
}
.player {
  border-radius: 15px !important;
  margin: 0 auto;
}
.text-content {
  margin-top: 1em;
}
.row {
  padding-bottom: 150px;
}
@media screen and (max-width: 767px) {
  .background {
    background-image: url("../assets/Sobre/background-mobile.svg");
  }
  .text {
    padding-left: 45px;
    padding-right: 45px;
  }

  .about {
    background-image: url("../assets/Sobre/fluid3-mobile.svg");
    background-repeat: no-repeat;
  }
  .row {
    padding-bottom: 100px;
  }
}
</style>
